import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/admin/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Admin Pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminHomePage = lazy(() => import('../pages/admin/home/page'));
const AdminAboutPage = lazy(() => import('../pages/admin/about/page'));
const AdminServicesPage = lazy(() => import('../pages/admin/services/page'));
const AdminProductsPage = lazy(() => import('../pages/admin/products/page'));
const AdminProjectsPage = lazy(() => import('../pages/admin/projects/page'));
const AdminSettingsPage = lazy(() => import('../pages/admin/settings/page'));
const AdminUsersPage = lazy(() => import('../pages/admin/users/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/projects',
    element: <ProjectsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin/dashboard',
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/home',
    element: (
      <ProtectedRoute>
        <AdminHomePage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/about',
    element: (
      <ProtectedRoute>
        <AdminAboutPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/services',
    element: (
      <ProtectedRoute>
        <AdminServicesPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/products',
    element: (
      <ProtectedRoute>
        <AdminProductsPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/projects',
    element: (
      <ProtectedRoute>
        <AdminProjectsPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/settings',
    element: (
      <ProtectedRoute>
        <AdminSettingsPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/admin/users',
    element: (
      <ProtectedRoute>
        <AdminUsersPage />
      </ProtectedRoute>
    )
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
